import axios from "axios";
import { useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import brandImage from "../assets/svg/chevrolet-10 1.svg";
import defaultImage from "../assets/svg/defultImage.svg";

const SelectVehicleModal = ({
  show,
  onHide,
  equipmentId,
  onSave,
  isTransfered,
  currentVehicleId,
}) => {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [fetchError, setFetchError] = useState(null);

  const { user } = useSelector((state) => state.auth);
  const token = user?.token;

  useEffect(() => {
    if (show) {
      fetchVehicles();
      setFetchError(null);
      setSelectedVehicle(null);
    }
  }, [show, equipmentId, token, isTransfered, currentVehicleId]);

  const fetchVehicles = async () => {
    setLoading(true);
    if (isTransfered) {
      try {
        const response = await axios.get(
          `https://estbn.com/EstbnNew/public/api/portal/equipment_vehicles?equipment_id=${equipmentId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.success) {
          setVehicles(response.data.data.vehicles || []);
          if (response.data.data.vehicles.length === 0) {
            setFetchError("No vehicles found for transfer.");
          }
        } else {
          console.error("API Error fetching transfer vehicles:", response.data);
          setFetchError(
            response.data.message || "Failed to fetch vehicles for transfer."
          );
        }
      } catch (error) {
        console.error("Error fetching transfer vehicles:", error);
        setFetchError(
          "Error fetching vehicles for transfer. Please try again."
        );
      }
    } else {
      try {
        const response = await axios.get(
          `https://estbn.com/EstbnNew/public/api/portal/door_step_vehicles`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.success) {
          setVehicles(response.data.data.door_step_vehicles || []);
          if (response.data.data.door_step_vehicles.length === 0) {
            setFetchError("No vehicles found.");
          }
        } else {
          console.error("API Error fetching vehicles:", response.data);
          setFetchError(response.data.message || "Failed to fetch vehicles.");
        }
      } catch (error) {
        console.error("Error fetching vehicles:", error);
        setVehicles([]);
        setFetchError("Error fetching vehicles. Please try again.");
      }
    }

    setLoading(false);
  };

  const handleSave = async () => {
    if (!selectedVehicle) {
      toast.error("Please select a vehicle first.");
      return;
    }

    setIsSaving(true);

    if (isTransfered) {
      try {
        const formData = new FormData();
        formData.append("equipment_id", equipmentId);
        formData.append("new_vehicle_id", selectedVehicle.id);

        const response = await axios.post(
          `https://estbn.com/EstbnNew/public/api/portal/equipments/${equipmentId}/vehicles/${currentVehicleId}/transfer`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        toast.success(
          response.data.message || "Equipment transferred successfully!"
        );
        handleClose();
        if (onSave) onSave();
      } catch (error) {
        console.error("Transfer error:", error);
        toast.error(
          error.response?.data?.errors?.message ||
            "Failed to transfer equipment."
        );
      }
    } else {
      try {
        const response = await axios.post(
          `https://estbn.com/EstbnNew/public/api/portal/equipments/${equipmentId}/vehicles/${selectedVehicle.id}/attach`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        toast.success(
          response.data.message || "Equipment assigned successfully!"
        );
        handleClose();
        if (onSave) onSave();
      } catch (error) {
        console.error("Attach error:", error);
        toast.error(
          error.response?.data?.errors?.message || "Failed to assign equipment."
        );
      }
    }
    setIsSaving(false);
  };

  const getProgressBarStyles = (value) => {
    const numericValue = typeof value === "number" ? value : 0;
    let bgColor = "bg-transparent";
    const scaledWidth = (numericValue / 10) * 100;

    if (numericValue > 7) {
      bgColor = "bg-success";
    } else if (numericValue > 3) {
      bgColor = "bg-warning";
    } else if (numericValue > 0) {
      bgColor = "bg-danger";
    }

    return { width: `${Math.max(0, Math.min(100, scaledWidth))}%`, bgColor };
  };

  const handleClose = () => {
    setSelectedVehicle(null);
    setFetchError(null);
    onHide();
  };

  console.log(vehicles);

  return (
    <Modal show={show} onHide={handleClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {isTransfered ? "Transfer to Vehicle" : "Select a Vehicle"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" role="status" />
            <p className="mt-2">Loading vehicles...</p>
          </div>
        ) : (
          <div className="row g-3">
            {fetchError ? (
              <p className="text-danger text-center py-4 w-100">{fetchError}</p>
            ) : vehicles.length > 0 ? (
              vehicles.map((van) => {
                const capacityStyles = getProgressBarStyles(van?.capacity);
                const workingHoursStyles = getProgressBarStyles(
                  van?.working_hours
                );
                return (
                  <div
                    key={van?.id}
                    className="col-12 col-lg-4 col-md-6 col-sm-12"
                  >
                    <div
                      onClick={() => {
                        setSelectedVehicle(van);
                      }}
                      className={`rounded-2 card bg-light h-100 cursor-pointer ${
                        selectedVehicle?.id === van?.id
                          ? "border border-primary border-3 shadow-sm"
                          : ""
                      }`}
                      style={{ position: "relative", overflow: "hidden" }}
                    >
                      <div className="d-flex align-items-center justify-content-between mt-3 mx-4">
                        <div className="d-flex align-items-center">
                          <img
                            style={{ width: 20 }}
                            src={brandImage}
                            alt="brand"
                          />
                          <h6
                            style={{
                              fontSize: 12,
                              marginInlineStart: 5,
                              marginBlockEnd: 0,
                            }}
                          >
                            {van?.name}
                          </h6>
                        </div>
                        <h6 className="fs-6 fw-bold m-0">Van # {van?.id}</h6>
                      </div>

                      <div
                        style={{ height: "180px" }}
                        className="d-flex justify-content-center align-items-center bg-white mx-4 my-3 rounded"
                      >
                        <img
                          className="img-fluid"
                          src={
                            isTransfered
                              ? van?.profile_photo_path
                                ? `https://estbn.com/EstbnNew/public${van?.profile_photo_path}`
                                : defaultImage
                              : van?.profile_photo_url
                              ? `https://estbn.com/EstbnNew/public/${van?.profile_photo_url}`
                              : defaultImage
                          }
                          alt="van"
                          style={{
                            maxHeight: "100%",
                            maxWidth: "100%",
                            objectFit: "contain",
                          }}
                        />
                      </div>

                      <div className="p-4 pt-0">
                        <div className="mb-3">
                          <h6 className="main-text-color label-van m-0 mb-1">
                            Van Capacity
                          </h6>
                          <div className="progress" style={{ height: "10px" }}>
                            <div
                              className={`progress-bar ${capacityStyles.bgColor}`}
                              role="progressbar"
                              style={{ width: capacityStyles.width }}
                              aria-valuenow={van?.capacity}
                              aria-valuemin="0"
                              aria-valuemax="10"
                            ></div>
                          </div>
                        </div>

                        <div className="mb-3">
                          <h6 className="main-text-color label-van m-0 mb-1">
                            Working hours
                          </h6>
                          <div className="progress" style={{ height: "10px" }}>
                            <div
                              className={`progress-bar ${workingHoursStyles.bgColor}`}
                              role="progressbar"
                              style={{ width: workingHoursStyles.width }}
                              aria-valuenow={van?.working_hours}
                              aria-valuemin="0"
                              aria-valuemax="10"
                            ></div>
                          </div>
                        </div>

                        <div className="d-flex justify-content-between align-items-center mt-3 mb-2">
                          <h6 className="main-text-color label-van m-0">
                            Services Categories
                          </h6>
                          <div>
                            {van.service_categories?.length > 0 ? (
                              <>
                                {van.service_categories.map((service) => (
                                  <img
                                    key={service.id}
                                    className="service-icon"
                                    src={
                                      "https://estbn.com/EstbnNew/public" +
                                      service.icon_url
                                    }
                                    alt="service-icon"
                                    style={{
                                      width: 18,
                                      height: 18,
                                      marginInlineEnd: 4,
                                    }}
                                  />
                                ))}
                              </>
                            ) : (
                              <div className="">
                                <p className="m-0 label-size">
                                  No Available Services
                                </p>
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="d-flex justify-content-between align-items-center my-2">
                          <h6 className="main-text-color m-0 label-van">
                            Supervisor
                          </h6>
                          {van?.supervisor?.length > 0 ? (
                            <span className="text-secondary">
                              {van.supervisor.map((s, index) => (
                                <span key={s.id}>
                                  {`${s.first_name} ${s.last_name}`}
                                  {index < van.supervisor.length - 1 && ", "}
                                </span>
                              ))}
                            </span>
                          ) : (
                            <div className="">
                              <p className="m-0 label-size">
                                No Available Supervisor
                              </p>
                            </div>
                          )}
                        </div>

                        {van.current_stuff?.length > 0 ? (
                          van.current_stuff.map((stuff) => (
                            <div
                              key={stuff.id}
                              className="d-flex justify-content-between align-items-center my-2"
                            >
                              <h6 className="main-text-color label-van m-0">{`${stuff.job_title?.title}`}</h6>
                              <h6 className="label-van m-0 text-secondary">
                                {stuff?.name}
                              </h6>
                            </div>
                          ))
                        ) : (
                          <div className="d-flex justify-content-between align-items-center my-2">
                            <h6 className="main-text-color m-0 label-van">
                              Staffs
                            </h6>
                            <div className="">
                              <p className="m-0 label-size">
                                No Available Staffs
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              !fetchError && (
                <p className="text-center py-4 w-100">No vehicles found</p>
              )
            )}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-end p-3 border-top">
        <Button
          variant="outline-secondary"
          onClick={handleClose}
          className="me-2"
        >
          Cancel
        </Button>
        <Button
          variant="dark"
          onClick={handleSave}
          disabled={isSaving || !selectedVehicle}
        >
          {isSaving ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              {isTransfered ? "Transferring..." : "Assigning..."}
            </>
          ) : isTransfered ? (
            "Transfer"
          ) : (
            "Assign"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SelectVehicleModal;
